<template>
<details>
	<summary>{{name}}</summary>
	<table class="entity-details">
		<tr v-for="item in details">
			<td class="key" :data-label="item.label"><span class="badge badge-info" :title="item.title">{{item.label}}</span></td>
			<td class="value">
				<jm-cell
				:entity="content"
				:view="item"
				></jm-cell>
			</td>
		</tr>
	</table>
</details>
</template>

<script>
import { ModelTableView } from '@/assets/js/ModelView'

export default {
	name: "JmEntity",

	props: {
		content: Object,
		view: Object
	},

	computed: {
		name () {
			return this.content.displayName();
		},

		details () {
			return this.$store.state.tables.views.entity.props
			.filter(p => this.notEmpty(p));
		}

	},

	methods: {

		notEmpty (view) {
			const value = view.value(this.content);

			return value instanceof ModelTableView
				? value.values(this.content).some(i => i !== undefined)
				: value !== undefined;
		}

	}
};
</script>

<style lang="stylus" scoped>
details > div
	font-family courier, monospace
	font-size 80%
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Entity.vue